/* eslint-disable no-tabs */
const IconSaveSvg = (props: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.292 3.878L20.121 8.707C20.683 9.269 21 10.033 21 10.829V18C21 19.657 19.657 21 18 21H16V17C16 15.897 15.102 15 14 15H10C8.897 15 8 15.897 8 17V21H6C4.343 21 3 19.657 3 18V6C3 4.343 4.343 3 6 3H8V10C8 10.552 8.447 11 9 11H15C15.553 11 16 10.552 16 10C16 9.448 15.553 9 15 9H10V3H13.172C13.967 3 14.73 3.316 15.292 3.878ZM9.9999 17H13.9999L14.0009 21H9.9999V17Z"
        fill="white"
      />
    </svg>
  )
}

export default IconSaveSvg
